function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".icon-versions" + shadowSelector + " {position: absolute;right: 0;}.container" + shadowSelector + " {cursor: pointer;}.list" + shadowSelector + " {box-shadow: none;border-top: none;border-right: none;border-left: none;border-bottom: none;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];